<template>
  <v-container>
    <!-- PAGE HEADING -->
    <v-row wrap>
      <v-flex xs2>
        <v-btn
          color="orange"
          text
          large
          @click="$router.push({'name': 'Home'})"
        >
          < Home
        </v-btn>
      </v-flex>
      <v-flex xs8 class="text-center">
        <span class="mr-5 headline pa-2">Library</span>
        <p class="px-2 body-1 grey--text">Browse the content and subscribe to decks.</p>

      </v-flex>
      <v-flex xs2>

      </v-flex>
    </v-row>


    <!-- DATA DEPENDENT CONTENT -->
    <div v-if="!$store.state.globalLoading && $store.state.availableDecksList != null">
      <!-- All data on this page is served from queries based in the store. -->
      <v-card class="pa-4 mb-3 pt-5">
        <v-row wrap>
          <v-flex xs12 sm6 md4 lg3 >
            <v-text-field
              v-model="$store.state.browseFilters.search"
              clearable
              class="mx-3"
              outlined
              prepend-inner-icon="mdi-magnify"
              label="Search"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3>
            <v-select
              v-model="$store.state.browseFilters.tags"
              class="mx-3"
              height="12"
              outlined
              chips
              deletable-chips
              label="Tags"
              :items="$store.getters.tagsForBrowse"
              multiple
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3>
            <v-select
              v-model="$store.state.browseFilters.subjects"
              class="mx-3"
              height="12"
              outlined
              chips
              deletable-chips
              label="Subjects"
              :items="$store.getters.subjectsForBrowse"
              multiple
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3>
            <v-switch
              v-model="$store.state.browseFilters.subscribedOnly"
              class="mx-3"
              height="12"
              outlined
              chips
              deletable-chips
              label="Show only Subscribed Decks"

            ></v-switch>
          </v-flex>



        </v-row>

      </v-card>


      <!-- <v-card>
        <v-data-table
          :headers="headers"
          :items="filteredDecks"
          class="display-1"
        >
          <template v-slot:item.manage="{ item }">
            <v-btn class="ml-2" dark small color="blue" v-if="!isSubscribed(item.id) && isVaidDomain(item.id).result" @click="subscribe(item.id)" >
              Subscribe
            </v-btn>
            <v-btn class="ml-2" dark small color="purple lighten-3" v-if="isSubscribed(item.id) && isVaidDomain(item.id).result" @click="unsubscribe(item.id)">
              Unsubscribe
            </v-btn>
            <div v-if="!isVaidDomain(item.id).result" class="overline blue--text text--darken-2">
              {{$store.state.availableDecksObject[item.id].domainAuth[0]}} Email Required
            </div>
          </template>
          <template v-slot:item.subject="{ item }">
            <v-chip small dark :color="$store.getters.subjectColor(item.subject)">
              {{item.subject}}
            </v-chip>

          </template>
        </v-data-table>
      </v-card> -->





      <v-card
        flat
        ripple
        outlined
        class="round-card pa-3 my-2"
        v-for="(deck, i) in filteredDecks"
        :key="i"
        >
        <v-row wrap class="ml-2">
          <v-flex xs12 md6>
            <div :class="$store.getters.subjectColor(deck.subject)">

                {{deck.subject}} | {{deck.lectureDate}}
            </div>
            <div class="body-1">
              {{deck.name}}
            </div>
          </v-flex>
          <v-flex xs2 md1>
            <div class="overline grey--text">
              Cards
            </div>
            <div>
              {{deck.deckLength}}
            </div>
          </v-flex>
          <v-flex xs4 md3>
            <div class="overline grey--text">
              Prior Practice Hx
            </div>
            <div>
              {{$store.getters.homeDeckLastPracticed(deck.id).text}}
            </div>
          </v-flex>
          <v-flex xs4 md2>
            <div class="overline grey--text">
              Action
            </div>
            <div>
              <!-- <v-btn class="ml-2" dark x-small rounded color="blue lighten-1" v-if="!isSubscribed(deck.id) && isVaidDomain(deck.id).result" @click="subscribe(deck.id)" >
                Subscribe
              </v-btn>
              <v-btn class="ml-2" dark x-small rounded color="purple lighten-3" v-if="isSubscribed(deck.id) && isVaidDomain(deck.id).result" @click="unsubscribe(deck.id)">
                Unsubscribe
              </v-btn> -->
              <v-btn class="ml-2" dark x-small rounded color="purple lighten-3" v-if="isSubscribed(deck.id) && isVaidDomain(deck.id).result" @click="unsubscribe(deck.id)">
                Unsubscribe
              </v-btn>
              <v-btn class="ml-2" x-small dark rounded color="blue lighten-2" v-if="!isSubscribed(deck.id) && isVaidDomain(deck.id).result" @click="$router.push({ name: 'Learn', params: {id: deck.id} })">
                Study/Subscribe
              </v-btn>
              <div v-if="!isVaidDomain(deck.id).result" class="caption grey--text">
                {{$store.state.availableDecksObject[deck.id].domainAuth[0]}} email required
              </div>

            </div>
          </v-flex>


        </v-row>
        <v-row>
        </v-row>
      </v-card>





      <v-card
        v-if="filteredDecks.length < $store.state.availableDecksList.length
        && filteredDecks.length > 0
        && $store.state.availableDecksList != null"
        @click="clearFilters()"
        class="pa-1 mt-2 text-center"
        color="grey"
        dark
        >
        You have one or more filters enabled. Click this message to clear all filters.
      </v-card>
      <v-card
        v-if="filteredDecks.length == 0"
        @click="clearFilters()"
        class="pa-1 mt-2 text-center"
        color="grey lighten"
        dark
        >
        It looks like the filters you picked don't match any decks. Change your filters or click this message to clear all filters.
      </v-card>

    </div>

  </v-container>

</template>

<script>
import firebase from 'firebase'
import _ from 'underscore'

export default {
  name: 'Browse',
  data() {
    return {
      headers: [
        {text: 'Name', value: 'name'},
        {text: 'Subject', value: 'subject'},
        {text: 'Lecture Date', value: 'lectureDate'},
        {text: '# of Cards', value: 'deckLength'},
        {text: 'Subscribed', value: 'manage'},

      ],
      userRef: firebase.firestore().collection('users').doc(firebase.auth().currentUser.uid)
    }
  },
  computed: {
    filteredDecks() {
      //filter stored in $store for page navigation persistence
      if (this.$store.state.availableDecksList != null) {
        let decks = this.$store.state.availableDecksList
        let filteredDecks = decks.filter(deck => {
          let matchSearch = true
          let matchTags = true
          let matchSubjects = true
          let subscribedFilter = true

          if (this.$store.state.browseFilters.search.length > 0) {
            let term = this.$store.state.browseFilters.search.toLowerCase()
            let deckString = (deck.name + " " + deck.subject).toLowerCase()
            deckString.includes(term) ? matchSearch = true : matchSearch = false
          }
          if (this.$store.state.browseFilters.tags.length > 0) {
            _.intersection(this.$store.state.browseFilters.tags, deck.tags).length > 0 ? true : matchTags = false

          }
          if (this.$store.state.browseFilters.subjects.length > 0) {
            this.$store.state.browseFilters.subjects.includes(deck.subject) ? true : matchSubjects = false
          }
          if (this.$store.state.browseFilters.subscribedOnly) {
            this.isSubscribed(deck.id) ? true : subscribedFilter = false
          }

          return matchSearch && matchTags && matchSubjects && subscribedFilter
        })
        filteredDecks = _.sortBy(filteredDecks, 'lectureDate').reverse()
        return filteredDecks

      }
      else {
        return []
      }
    }
  },
  mounted() {
    if (this.$route.query.subject && this.$store.getters.subjectsForBrowse.includes(this.$route.query.subject)) {
      this.$store.state.browseFilters.subjects = [this.$route.query.subject]
    }
  },
  methods: {
    test(i) {
      console.log(i)
    },

    //BUTTON ACTIONS
    toggleDeck(id) {
      if (this.isSubscribed(id)) {
        this.unsubscribe(id)
      }
      else {
        this.subscribe(id)
      }
    },

    subscribe(deckId) {
      this.userRef.update({
        subscribedDecks: firebase.firestore.FieldValue.arrayUnion(deckId)
      }).then(() => {
        this.$store.commit('snackbarMessageSet', {
          color: 'blue lighten-2',
          message: 'You subscribed to the deck.'
        })

      })
    },
    unsubscribe(deckId) {
      this.userRef.update({
        subscribedDecks: firebase.firestore.FieldValue.arrayRemove(deckId)
      }).then(() => {
        this.$store.commit('snackbarMessageSet', {
          color: 'purple lighten-2',
          message: 'You unsubscribed from the deck.'
        })
      })
    },
    clearFilters() {
      this.$store.state.browseFilters.subjects = []
      this.$store.state.browseFilters.tags = []
      this.$store.state.browseFilters.search = ""
      this.$store.state.browseFilters.subscribedOnly = false
    },

    //UI FUNCTIONS

    isSubscribed(deckId) {
      if (this.$store.state.userData.subscribedDecks.includes(deckId)) {
        return true
      }
      else {
        return false
      }
    },
    isVaidDomain(deckId) {
      if (this.$store.state.availableDecksObject[deckId].domainAuth.length > 0) {

        //check to see if the user has an authroized domain
        //only check if there is a specified domain on the deck

        let intersection = _.intersection( //compute union of required and provided domains
            this.$store.state.availableDecksObject[deckId].domainAuth,
            this.$store.state.userData.domainAuth
          )
        console.log(intersection)
        if (intersection.length > 0) {
          return {result:true, color:'white'}
        }
        else {
          return {result:false, color:'grey'}
        }
      } else {
        return {result:true, color:'white'}
      }
    }

  }
}
</script>
